import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import type { RouteLocationNormalized } from "vue-router"

const isInvalidQueryParam = (key: string, value: unknown): boolean => {
	if (!key || key.trim() === '') return true;

	if (value === null || value === undefined) return true;

	if (typeof value === 'string' && value.trim() === '') return true;

	if (Array.isArray(value)) {
		if (value.length === 0) return true;
		return value.every(v => !v || (typeof v === 'string' && v.trim() === ''));
	}

	return false
}

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (to.matched.length === 0) return;

	let hasInvalidParams = false;
	const cleanedQuery: Record<string, string | string[]> = {};

	for (const [key, value] of Object.entries(to.query)) {
		if (isInvalidQueryParam(key, value)) {
			hasInvalidParams = true;
			continue;
		}

		cleanedQuery[key] = value as string | string[]
	}

	if (!hasInvalidParams) return;

	return navigateTo({
		path: to.path,
		query: cleanedQuery
	}, {
		replace: true
	});
})
